import { axiosInstance as request } from '@api/rest.service'

const api = id => `/to-dos/${id}/checklist-items`

/**
 * @description GET /to-dos/{id}/checklist-items
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_CHECKLIST_ITEMS = id => request.get(api(id))

/**
 * @description POST /to-dos/{id}/checklist-items
 * @returns {AxiosPromise<any>}
 */
export const CREATE_TODOS_CHECKLIST = (id, payload) => request.post(api(id), payload)

/**
 * @description PUT /to-dos/{id}/checklist-items/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_TODOS_CHECKLIST = (todoId, id, payload) => request.put(`${api(todoId)}/${id}`, payload)

/**
 * @description DELETE /to-dos/{id}/checklist-items/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_TODOS_CHECKLIST = (todoId, id) => request.delete(`${api(todoId)}/${id}`)
